import React from "react";
import Flagship from "../../core/flagship";
import { connect } from "react-redux";
import {
  Loader,
  Header,
  Grid,
  Modal,
  Button,
  Icon,
  Label
} from "semantic-ui-react";
import {
  empty,
  renderFieldValue,
  shouldShowField,
  getServiceNiceName
} from "../../utils/helpers";
import Linkify from "react-linkify";

class LineItemViewModal extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = this.getInitialState();
    this.editName = this.editName.bind(this);
    this.duplicateLineItem = this.duplicateLineItem.bind(this);
  }

  getInitialState() {
    return {
      loading: true,
      id: this.props.lineItemId,
      line_item_key: "",
      line_item_name: "",
      line_item_type: "",
      parent_rfp: 0,
      vendor: "",
      cogs: "",
      price: "",
      lineItemData: {},
      lineItemForm: [],
      errors: []
    };
  }

  componentDidMount() {
    // Get Form
    this.getLineItemForm();
  }

  getLineItemForm() {
    let self = this;
    let service = this.props.lineItem.line_item_type;

    let mainService = false;
    let subService = false;

    Flagship.config.lineItemServices.map(function(element) {
      if (element.value === service) {
        mainService = service;
      } else if (element.hasOwnProperty("subOptions")) {
        element.subOptions.map(function(subItem) {
          if (subItem.value === service) {
            mainService = element.value;
            subService = service;
          }
        });
      }
    });

    if (subService !== false) {
      // If dealing with a sub-service, get both levels of fields

      this.getFormSubService(mainService, subService);
    } else {
      Flagship.get(
        "fields/line-item_" + mainService,
        {
          withData:
            typeof this.props.lineItemId === "undefined"
              ? false
              : this.props.lineItemId,
          dataSource: "line_item",
          active: true,
          instance: this.props.instance
        },
        function(response) {
          if (response.data.success === true) {
            self.setState({
              loading: false,
              lineItemData: response.data.fieldData,
              originalLineItemData: response.data.fieldData,
              lineItemForm: response.data.results
            });
          } else {
            Flagship.error(
              "Error getting line item form from Flagship API server.",
              self.props.recordId,
              self.props.userId
            );
          }
        },
        function(err) {
          Flagship.error(
            "Error getting line item form from Flagship API server: " + err,
            self.props.recordId,
            self.props.userId
          );
        }
      );
    }
  }

  getFormSubService(mainService, subService) {
    let self = this;

    // First get main service fields
    Flagship.get(
      "fields/line-item_" + mainService,
      {
        withData:
          typeof this.props.lineItemId === "undefined"
            ? false
            : this.props.lineItemId,
        dataSource: "line_item",
        active: true
      },
      function(response) {
        if (response.data.success === true) {
          self.setState(
            {
              lineItemForm: response.data.results,
              lineItemData: response.data.fieldData,
              originalLineItemData: response.data.fieldData
            },
            function() {
              self.getSubServiceFields(subService);
            }
          );
        } else {
          Flagship.error(
            "Error getting line item form from Flagship API server.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Error getting line item form from Flagship API server: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  getSubServiceFields(subService) {
    let self = this;

    // Now add sub service fields
    Flagship.get(
      "fields/line-item_" + subService,
      {
        withData:
          typeof this.props.lineItemId === "undefined"
            ? false
            : this.props.lineItemId,
        dataSource: "line_item",
        active: true
      },
      function(response) {
        if (response.data.success === true) {
          let combinedForm = [
            ...self.state.lineItemForm,
            ...response.data.results
          ];
          let combinedData = Object.assign(
            self.state.lineItemData,
            response.data.fieldData
          );

          self.setState({
            lineItemForm: combinedForm,
            lineItemData: combinedData,
            loading: false
          });
        } else {
          Flagship.error(
            "Error getting line item form from Flagship API server.",
            self.props.recordId,
            self.props.userId
          );
        }
      },
      function(err) {
        Flagship.error(
          "Error getting line item form from Flagship API server: " + err,
          self.props.recordId,
          self.props.userId
        );
      }
    );
  }

  onChange(e, data, field) {
    let parentOnChange = this.props.onChange;

    let newState = Object.assign({}, this.state);

    newState[field] = data;

    this.setState(newState, function() {
      parentOnChange(this.state);
    });
  }

  editName() {
    this.setState({
      editingName: true
    });
  }

  duplicateLineItem(e, data) {
    if (this.props.accessLevel !== 2) {
      return;
    }

    this.props.duplicateLineItem(e, data, this.state);
  }

  render() {
    let self = this;
    let serviceNiceName = getServiceNiceName(
      this.props.lineItem.line_item_type
    );
    if (this.state.loading === true) {
      return <Loader />;
    } else {
      return (
        <Modal
          open={this.props.open}
          onClose={this.props.cancelUpdate}
          closeIcon
        >
          {this.props.userRole !== "ae" && this.props.accessLevel === 2
            ? [
                <Button
                  key="edit-button"
                  floated="right"
                  className="view-edit-line-item"
                  onClick={this.props.swapToEdit}
                >
                  <Icon name="edit" />
                  Edit
                </Button>,
                <Button
                  key="copy-button"
                  floated="right"
                  className="view-edit-line-item"
                  onClick={this.duplicateLineItem}
                >
                  <Icon name="copy" />
                  Duplicate
                </Button>
              ]
            : null}
          <Header>
            {this.props.lineItem.line_item_key +
              " - " +
              this.props.lineItem.line_item_name}
            {serviceNiceName !== this.props.lineItem.line_item_name ? (
              <div className="gray-text">
                <small> ({serviceNiceName}) </small>
              </div>
            ) : null}
          </Header>

          <Modal.Content>
            <div>
              <Grid>
                <Grid.Column width={16}>
                  <Header as="h3">
                    Line Item Info
                    <div className="float-right">
                      {!empty(this.props.lineItem.price) ? (
                        <Label
                          color="blue"
                          image
                          style={{ margin: "0 1em 1em 0" }}
                        >
                          Price
                          <Label.Detail>
                            {renderFieldValue(
                              this.props.lineItem.price,
                              "money"
                            )}
                          </Label.Detail>
                        </Label>
                      ) : null}

                      {!empty(this.props.lineItem.cogs) ? (
                        <Label
                          color="grey"
                          image
                          style={{ margin: "0 1em 1em 0" }}
                        >
                          COGS
                          <Label.Detail>
                            {renderFieldValue(
                              this.props.lineItem.cogs,
                              "money"
                            )}
                          </Label.Detail>
                        </Label>
                      ) : null}

                      {!empty(this.props.lineItem.vendor) ? (
                        <Label
                          color="orange"
                          image
                          style={{ margin: "0 1em 1em 0" }}
                        >
                          Vendor
                          <Label.Detail>
                            {this.props.lineItem.vendor}
                          </Label.Detail>
                        </Label>
                      ) : null}
                    </div>
                  </Header>

                  {!empty(this.state.lineItemData[397]) ? (
                    <div style={{ padding: "1em .5em" }}>
                      <strong>NOTE:</strong> {self.state.lineItemData[397]}
                    </div>
                  ) : null}

                  {!empty(this.props.lineItem.flights) ? (
                    <div
                      key={"io-product-render-field-flights"}
                      className="flagship-single-field single-record-single-field"
                    >
                      {renderFieldValue(
                        this.props.lineItem.flights,
                        this.props.lineItem.line_item_type === "email-marketing"
                          ? "deployment"
                          : "flight"
                      )}
                    </div>
                  ) : null}

                  {!empty(this.state.lineItemForm.length)
                    ? this.state.lineItemForm.map(function(item, i) {
                        if (!empty(self.state.lineItemData)) {
                          let value = self.state.lineItemData.hasOwnProperty(
                            item.field_id
                          )
                            ? self.state.lineItemData[item.field_id]
                            : "";

                          if (!empty(value)) {
                            return shouldShowField(
                              item,
                              self.state.lineItemData
                            ) ? (
                              <div
                                key={"line-item-render-field-" + i}
                                className="flagship-single-field single-record-single-field"
                              >
                                {!empty(item.label) ? (
                                  <div>
                                    <Label>{item.label}</Label> <br />
                                  </div>
                                ) : null}
                                <div className="field-value">
                                  {item.type === "textarea" ? (
                                    <Linkify properties={{ target: "_blank" }}>
                                      {renderFieldValue(value, item.validation)}
                                    </Linkify>
                                  ) : (
                                    renderFieldValue(value, item.validation)
                                  )}
                                </div>
                              </div>
                            ) : null;
                          }
                        }
                      })
                    : "No IO Product data."}
                </Grid.Column>
              </Grid>
            </div>
          </Modal.Content>
        </Modal>
      );
    }
  }
}

function mapStateToProps(state) {
  return {
    username: state.main.username,
    userId: state.main.userId,
    userRole: state.main.userRole,
    instance: state.main.instance
  };
}

export default connect(mapStateToProps, null)(LineItemViewModal);



// WEBPACK FOOTER //
// ./src/components/modals/LineItemViewModal.js